import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useSeo } from "@/lib/useSeo";
import NewsletterForm from "@/components/NewsletterForm";
import { ArrowRight } from "@phosphor-icons/react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useSeo({
    title: "Blog & Buyer's Guides — Stuffly",
    description: "Long-form buyer's guides, NZ travel & gear tips, product roundups and how-tos from the Stuffly team.",
    path: "/blog",
  });

  useEffect(() => {
    api.get("/posts").then(r => setPosts(r.data.items || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="border-b border-zinc-900 px-6 md:px-12 py-10">
        <div className="tag mb-3">The Blog</div>
        <h1 className="text-4xl sm:text-5xl font-black tracking-tighter uppercase font-[Outfit]" data-testid="blog-heading">
          Buyer's Guides &<br />Field Notes.
        </h1>
        <p className="text-sm text-zinc-600 mt-3 max-w-xl">Honest reviews and how-tos from the Stuffly team. New posts every fortnight.</p>
      </div>

      {loading ? (
        <div className="p-16 text-center text-xs uppercase tracking-widest font-bold font-[Outfit]">Loading…</div>
      ) : posts.length === 0 ? (
        <div className="p-16 text-center text-sm text-zinc-600">No posts yet — check back soon.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-borders border-l border-zinc-900 border-b">
          {posts.map(p => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="group bg-white flex flex-col" data-testid={`blog-card-${p.slug}`}>
              <div className="aspect-[16/10] bg-zinc-100 overflow-hidden border-b border-zinc-900">
                {p.cover_image && <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />}
              </div>
              <div className="p-6 flex flex-col flex-1">
                <div className="flex flex-wrap gap-1 mb-3">
                  {(p.tags || []).slice(0, 3).map(t => <span key={t} className="tag text-[0.6rem]">{t}</span>)}
                </div>
                <h2 className="text-xl font-black tracking-tight uppercase font-[Outfit] leading-tight group-hover:text-[#ff3333]">{p.title}</h2>
                <p className="text-sm text-zinc-600 mt-3 flex-1 line-clamp-3">{p.excerpt}</p>
                <div className="mt-4 text-xs uppercase tracking-widest font-bold font-[Outfit] flex items-center gap-2">
                  Read Article <ArrowRight size={14} weight="bold" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}

      <div className="border-b border-zinc-900 bg-zinc-900 text-white relative noise px-6 md:px-12 py-12">
        <div className="max-w-xl">
          <div className="tag mb-3 bg-[#ff3333] text-white border-[#ff3333]">Newsletter</div>
          <h2 className="text-3xl font-black tracking-tighter uppercase font-[Outfit]">Deals & Guides,<br />Straight To Your Inbox.</h2>
          <p className="text-sm opacity-70 mt-3 mb-5">One email a fortnight. New arrivals, buyer's guides and subscriber-only offers. Unsubscribe anytime.</p>
          <NewsletterForm dark />
        </div>
      </div>
    </div>
  );
}
